(() => {
  let adding = false;
  const root = window.Shopify?.routes?.root || '/';
  const sections = ['cart-drawer', 'cart-icon-bubble'];
  const request = async (path, data) => {
    const response = await fetch(root + path, data ? {method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify(data)} : {headers:{Accept:'application/json'}});
    const result = await response.json();
    if (!response.ok || result.status) throw new Error(result.description || 'Unable to update your cart.');
    return result;
  };
  const render = (drawer, cart) => {
    if (!cart.sections || sections.some(key => !cart.sections[key])) { location.assign(root + 'cart'); return false; }
    drawer.classList.toggle('is-empty', cart.item_count === 0);
    drawer.renderContents(cart);
    return true;
  };
  document.addEventListener('change', event => {
    const select = event.target.closest('[data-dod-cart-variant]');
    if (!select) return;
    const card = select.closest('.dod-cart__addon');
    const price = card.querySelector('.dod-cart__offer-price');
    const option = select.selectedOptions[0];
    const cents = Number(option.dataset.price);
    const money = amount => new Intl.NumberFormat(document.documentElement.lang || 'en-US',{style:'currency',currency:price.dataset.currency || 'USD'}).format(amount / 100);
    card.querySelector('[data-dod-cart-add]').dataset.dodCartAdd = option.value;
    const original = price.querySelector('[data-offer-original]');
    if (original) original.textContent = money(cents);
    price.querySelector('[data-offer-price]').textContent = money(cents);
  });
  document.addEventListener('click', async event => {
    const scroll = event.target.closest('[data-dod-cart-scroll]');
    if (scroll) {
      const rail = scroll.closest('[data-dod-addons]').querySelector('.dod-cart__addon-grid');
      if (rail.firstElementChild) rail.scrollBy({left:Number(scroll.dataset.dodCartScroll) * (rail.firstElementChild.getBoundingClientRect().width + 10),behavior:matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'});
      return;
    }
    const button = event.target.closest('[data-dod-cart-add]');
    if (!button || adding) return;
    const drawer = button.closest('cart-drawer');
    if (!drawer) return;
    const area = button.closest('[data-dod-addons]');
    const variantId = Number(button.dataset.dodCartAdd);
    const label = button.textContent;
    const controls = [...drawer.querySelectorAll('button, input, select')].filter(control => !control.disabled && !control.classList.contains('drawer__close'));
    const status = area.querySelector('[data-dod-cart-status]');
    const scrollTop = drawer.querySelector('cart-drawer-items')?.scrollTop || 0;
    adding = true;
    const releaseTierLock = window.DODGameTiers?.begin();
    controls.forEach(control => control.disabled = true);
    button.textContent = button.dataset.adding;
    status.textContent = '';
    let added = false;
    let cart;
    try {
      cart = await request('cart/add.js',{items:[{id:variantId,quantity:1}],sections,sections_url:location.pathname});
      added = true;
      if (window.DODGameTiers) cart = await window.DODGameTiers.sync(cart);
      if (!render(drawer,cart)) return;
      const message = drawer.querySelector('[data-dod-cart-status]');
      if (message) message.textContent = button.dataset.added;
      const scroller = drawer.querySelector('cart-drawer-items');
      if (scroller) scroller.scrollTop = scrollTop;
      drawer.querySelector('#CartDrawer-Checkout')?.focus({preventScroll:true});
      if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') publish(PUB_SUB_EVENTS.cartUpdate,{source:'dod-cart-offer',productVariantId:variantId,cartData:cart});
    } catch (error) {
      if (added) {
        try {
          cart = await request('cart/update.js',{sections,sections_url:location.pathname});
          if (render(drawer,cart)) {
            const message = drawer.querySelector('[data-dod-cart-status]');
            if (message) message.textContent = 'Game added. Please check your savings before checkout.';
          }
        } catch (_) { location.assign(root + 'cart'); }
      } else if (status.isConnected) status.textContent = error.message || button.dataset.error;
    } finally {
      adding = false;
      releaseTierLock?.();
      controls.forEach(control => { if (control.isConnected) control.disabled = false; });
      if (button.isConnected) button.textContent = label;
    }
  });
})();

